import React, { Component } from 'react';
import logo_icon from './img/logo.png';
import './index.less';
/**
 * 页头
 */
class Header extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            actTitle: '首页',
            data: [
                {
                    title: '首页',
                    target: '_blank',
                    href: '',
                    // }, {
                    //     title: '招聘官网定制',
                    //     target: '_blank',
                    //     href: '//atsmade.58.com/function/case-case/#/case-library/home'
                }, {
                    title: '微招聘',
                    target: '_blank',
                    href: '//ats.chinahr.com/weixin.html',
                }, {
                    title: '招聘管家',
                    target: '_blank',
                    href: '//ats.chinahr.com/index.html'
                }, {
                    title: '在线测评',
                    target: '_blank',
                    href: '/pages/cn/evaluation'
                }, {
                    title: '背调服务',
                    target: '_blank',
                    href: '/pages/cn/backtone'
                }, {
                    title: '在线笔试',
                    target: '_blank',
                    href: '/pages/cn/exame'
                }, {
                    title: '员工管家',
                    target: '_blank',
                    href: '//employee.chinahr.com/settle/ci/leaflet'
                    // },
                    // {
                    //     title: '在线宣讲',
                    //     target: '_blank',
                    //     href: '//campus.chinahr.com/pages/xuanjiang2021/'
                }, {
                    title: 'AI面试',
                    target: '_blank',
                    href: '//chrcampus.chinahr.com/news/ai-introduction/'
                }

            ],
        }
    }

    handleMouseEnter = (item) => {
        const me = this;
        me.setState({
            actTitle: item.title
        })
    }

    handleMouseLeave = () => {
        const me = this;
        me.setState({
            actTitle: '首页'
        })
    }
    render() {
        const me = this;
        const {
            actTitle,
            data
        } = me.state;
        return (
            <div className="header">
                <div className="header__nav">
                    <img src={logo_icon} className="header__nav-logo" />
                    <ul className="header__nav-items">
                        {
                            data.map((item, index) => {
                                return (
                                    <li
                                        className={actTitle === item.title ? 'header__nav-items-active' : ''}
                                        key={index}
                                        onMouseEnter={() => me.handleMouseEnter(item)}
                                        onMouseLeave={() => me.handleMouseLeave(item)}
                                    >
                                        <a
                                            href={`${item.href}`}
                                            target={item.target}
                                        >
                                            {item.title}
                                        </a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default Header;